<div class="card">
  <div class="card-header">
    <button class="btn btn-light" (click)="hideModel(false)">
      < Back</button>
        {{job.name}}

        <button style="float: right;" class="btn btn-danger-soft" (click)="deleteJob(job)">
          <img src="../assets/img/loading_2.svg" alt="loading scans" *ngIf="loading['delete']"
            style="width: 18px; margin-right: 6px;" />
          Delete
        </button>
        <button style="float: right;" class="btn btn-primary-soft" (click)="load()">
          Refresh
        </button>
  </div>
</div>
<div class="card-body">
  <div class="flex-left">
    <div>
      <div class="progress-container" *ngIf="job.status == 'Completed'">
        <div class="progress-header">
          Test Score
          <img src="../assets/img/loading_2.svg" alt="loading scans" *ngIf="loading['checks']"
            style="width: 18px; margin-right: 6px;" />

        </div>
        <div class="progress-body">
          <div style="height: 300px; width: 100%;" id="testscore_graph"></div>
        </div>
      </div>
      <div class="progress-container" *ngIf="job.status != 'Completed'">
        <div class="progress-header">
          Scan Progress
          <img src="../assets/img/loading_2.svg" alt="loading scans" style="width: 18px; margin-right: 6px;" />
        </div>
        <div class="progress-body">
          <div style="height: 300px; width: 100%;" id="testscore_graph"></div>
        </div>
      </div>
    </div>
    <div class="progress-container">
      <div class="progress-header">Check Types</div>
      <div class="progress-body">
        <div id="graphMain" style="width: 100%; height: 300px;" *ngIf="timer || !loading['checks']">
        </div>
        <div style="position: relative; width: 100%; height: 300px;" *ngIf="!timer && loading['checks']">
          <div class="round_loader loader"></div>
        </div>
      </div>
    </div>
    <div class="progress-container">
      <div class="progress-header">Failed Checks</div>
      <div class="progress-body">
        <div id="failedGraph" style="width: 100%; height: 300px;" *ngIf="timer || !loading['checks']">
        </div>
        <div style="position: relative; width: 100%; height: 300px;" *ngIf="!timer && loading['checks']">
          <div class="round_loader loader"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="progress-container">
    <div class="progress-header">
      <div>
        Checks
      </div>
      <button class="btn btn-light filter_click">
        <i class="fa fa-filter" aria-hidden="true"></i>
        <div style="font-size: 0.9em;">
          <div>
            {{ filter['checks'] }}
          </div>
        </div>
        <div class="filter_dropdown">
          <div class="filter-item" (click)="filter['checks'] = 'ALL'">
            <div class="filter-checkbox" [ngClass]="{checked: filter['checks'] == 'ALL'}">

            </div>
            <div>
              All
            </div>
          </div>
          <div class="filter-item" (click)="filter['checks'] = 'Automatic'">
            <div class="filter-checkbox" [ngClass]="{checked: filter['checks'] == 'Automatic'}">

            </div>
            <div>
              Automatic
            </div>
          </div>
          <div class="filter-item" (click)="filter['checks'] = 'Manual'">
            <div class="filter-checkbox" [ngClass]="{checked: filter['checks'] == 'Manual'}">

            </div>
            <div>
              Manual
            </div>
          </div>
          <div class="filter-item" (click)="filter['checks'] = 'Passed'">
            <div class="filter-checkbox" [ngClass]="{checked: filter['checks'] == 'Passed'}">

            </div>
            <div>
              Passed
            </div>
          </div>
          <div class="filter-item" (click)="filter['checks'] = 'Failed'">
            <div class="filter-checkbox" [ngClass]="{checked: filter['checks'] == 'Failed'}">

            </div>
            <div>
              Failed
            </div>
          </div>
        </div>
      </button>
    </div>
    <div class="progress-body">
      <div [ngClass]="{expanded: check.expanded}" *ngFor="let check of filterChecks()">
        <div class="check" (click)="loadCheckDetailed(check)" id="check_{{ check['check_id'] }}">
          <div class="check_inner" [attr.data-status]="check.type">
            <div class="status"
              [ngStyle]="{'background-color': ((check.failed > 0 || (check.type != 'Manual' && check.failed == 0 && check.passed == 0)) && 'rgb(243, 115, 115)') ||( (check.passed > 0 && check.failed == 0) && 'rgb(92, 156, 92)') || check.type == 'Manual' && 'rgb(240 175 30)'}">
              <ng-container class="status"
                *ngIf="check.failed > 0 || (check.type != 'Manual' && check.failed == 0 && check.passed == 0)">
                Failed
              </ng-container>
              <ng-container class="status" *ngIf="check.passed > 0 && check.failed == 0">
                Passed
              </ng-container>
              <ng-container class="status" *ngIf="check.type == 'Manual'">
                Manual
              </ng-container>
            </div>
            <div style="flex: 1; padding: 6px;">
              <div style="display: flex; justify-content: space-between; align-items: center;">
                <div style="flex: 1;">
                  <div style="font-size: 1.2em; cursor: pointer;">{{ check.name }}</div>
                </div>
              </div>
              <div class="nav-link" style="padding: 0px; font-size: 0.9em;">
                RULE ID: {{ check.check_id }}
              </div>
              <div class="tag_list">
                <div class="tag">
                  <div class="tag_item">{{ check['failed'] + check['passed'] }}</div>
                  <div class="tag_item">Tested</div>
                </div>
                <div class="tag passed">
                  <div class="tag_item">{{ check['passed'] }}</div>
                  <div class="tag_item">Passed</div>
                </div>
                <div class="tag failed">
                  <div class="tag_item">{{ check['failed'] }}</div>
                  <div class="tag_item">Failed</div>
                </div>
              </div>
            </div>
            <div class="down-arrow">
              <i class="fa fa-caret-down" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div *ngIf="check.expanded" class="mb-2" (click)="prevent($event)" style="padding: 10px 10px 10px 25px;">
          <div
            style="font-size: 1.1em; border-bottom: 1px solid grey; padding-bottom: 5px; display: flex; align-items: center; justify-content: space-between;">
            <span>
              Findings
            </span>
            <div style="display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
              <button class="btn btn-light filter_click">
                <i class="fa fa-filter" aria-hidden="true"></i>
                <div style="font-size: 0.9em;">
                  <div>
                    {{ filter['findings'] }}
                  </div>
                </div>
                <div class="filter_dropdown">
                  <div class="filter-item" (click)="filter['findings'] = 'ALL'">
                    <div class="filter-checkbox" [ngClass]="{checked: filter['findings'] == 'ALL'}">

                    </div>
                    <div>
                      All
                    </div>
                  </div>
                  <div class="filter-item" (click)="filter['findings'] = 'Passed'">
                    <div class="filter-checkbox" [ngClass]="{checked: filter['findings'] == 'Passed'}">

                    </div>
                    <div>
                      Passed
                    </div>
                  </div>
                  <div class="filter-item" (click)="filter['findings'] = 'Failed'">
                    <div class="filter-checkbox" [ngClass]="{checked: filter['findings'] == 'Failed'}">

                    </div>
                    <div>
                      Failed
                    </div>
                  </div>
                </div>
              </button>
              <div style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;"
                *ngIf="check['pagination']">
                <div>
                  Per Page:
                </div>
                <div>
                  <select style="padding: 5px; background-color: transparent;"
                    [(ngModel)]="check['pagination']['per_page']" (change)="changePerPage(check)">
                    <option [ngValue]="count" *ngFor="let count of perPages">{{ count }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="!check['loading']">
            <div class="finding" *ngFor="let finding of filterFindings(check.findings) | paginate
              : {
                  itemsPerPage: check['pagination'].per_page,
                  currentPage: check['pagination'].page,
                  totalItems: filterFindings(check.findings).length
                }; let i = index">
              <div class="mb-2">
                <div style="display: flex; justify-content: flex-start; align-items: flex-start;">
                  <h5 style="flex: 1;">{{ (check['pagination']['per_page'] * (check['pagination']['page'] - 1)) + (i +
                    1) }}. {{ finding['name'] }}
                  </h5>
                  <div><span *ngIf="finding['resource']">
                      Resource: {{ finding['resource'] }}
                    </span> <span *ngIf="finding['region']">| Region: {{
                      finding['region'] }}</span></div>
                </div>
              </div>
              <ng-container *ngIf="finding['status'] == 'Manual' || finding['status'] == false">
                <div class="mb-2">
                  <div style="font-weight: bold;">Reason</div>
                  <div>{{ finding['reason'] }}</div>
                </div>
                <div class="mb-2" style="display: flex; justify-content: flex-start; align-items: center; gap: 8px;"
                  *ngIf="finding['fix']">
                  <div><a target="_blank" href="{{ finding['fix'] }}" class="btn btn-primary-soft"><span
                        style="display: flex; gap: 8px; align-items: center;">
                        <span>Fix</span> <i class="fa fa-external-link" aria-hidden="true"></i>
                      </span>
                    </a></div>
                  <div *ngIf="finding['actions'] && getObjectKeys(finding['actions']).length > 0">
                    <div *ngFor="let key of getObjectKeys(finding['actions'])"><a target="_blank"
                        href="{{ finding['actions'][key] }}" class="btn btn-primary-soft"><span
                          style="display: flex; gap: 8px; align-items: center;">
                          <img src="../assets/img/aws_logo_1.png" alt="" style="height: 14px;">
                          <span>{{ key }}</span>
                          <i class="fa fa-external-link" aria-hidden="true"></i>
                        </span>
                      </a></div>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="finding['status'] == true">
                Passed
              </ng-container>
            </div>
            <div class="paginator">
              <pagination-controls class="pagination" previousLabel="Prev" nextLabel="Next"
                (pageChange)="onTableDataChange($event, check)">
              </pagination-controls>
            </div>
          </ng-container>
          <ng-container *ngIf="check['loading']">
            <div style="text-align: center;">
              <img src="../assets/img/loading_2.svg" alt="loading scans" style="width: 18px; margin: 10px" />
            </div>
          </ng-container>
        </div>
      </div>
      <div style="text-align: center;" *ngIf="loading['checks'] || timer">
        <img src="../assets/img/loading_2.svg" alt="loading scans" style="width: 18px; margin: 6px;" />
      </div>
    </div>
  </div>
</div>